import { Stack } from '@mui/material';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const ConfigContainer = styled(Stack)(({ theme }) => ({
  border: getBorder(theme.palette.border.default),
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  boxShadow: theme.shadows[1],
}));

const ConfigHeader = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  gap: theme.spacing(1),
  alignItems: 'center',
  flexDirection: 'row',
}));

export { ConfigHeader, ConfigContainer };
